var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered h-100"},[_vm._m(0),_c('p',[_vm._v("A página não foi encontrada.")]),_c('router-link',{staticClass:"breadcrumb-link",attrs:{"to":{name: 'Home'}}},[_vm._v("\n      Tela inicial\n    ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('i',{staticClass:"not-found-icon nc-icon nc-puzzle-10"}),_vm._v("404")])
}]

export { render, staticRenderFns }